import { render, staticRenderFns } from "./ContentSlide.vue?vue&type=template&id=1f001b5e&scoped=true"
import script from "./ContentSlide.vue?vue&type=script&lang=ts"
export * from "./ContentSlide.vue?vue&type=script&lang=ts"
import style0 from "./ContentSlide.vue?vue&type=style&index=0&id=1f001b5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f001b5e",
  null
  
)

export default component.exports